import React, { useState } from 'react';
import Footer from '../../Shared/Footer/Footer';
import Navbar from '../../Shared/Navbar/Navbar';
import AppointMentForm from '../AppointMentForm/AppointMentForm';
import AppointMentTop from '../AppointMentTop/AppointMentTop';
import BookApointMent from '../BookApointMent/BookApointMent';
import Appointment_Navbar from '../../Shared/Appointment_Navbar/Appointment_Navbar';
// import 
const AppointMent = () => {
    const [selectDate, setSelectedDate] = useState(new Date());
    const [isModalOpen, setIsModalOpen] = useState(false);

    const handleDateChange = (date) => {
        setSelectedDate(date)
    }
    const openModal = () => {
        setIsModalOpen(true);
    };

    const closeModal = () => {
        setIsModalOpen(false);
    };
    return (
        <div>
            <Appointment_Navbar></Appointment_Navbar>
            <AppointMentTop handleDateChange={handleDateChange} key={10}></AppointMentTop>
            <BookApointMent selectDate={selectDate} key={6}></BookApointMent>
            <AppointMentForm modalIsOpen={isModalOpen} appointMentDate={selectDate} closeModal={closeModal} date={selectDate}></AppointMentForm>
            <Footer></Footer>
        </div>
    );
};

export default AppointMent;